import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const getCoachHasMainOffer = createServerFn({ method: "GET" })
  .validator(z.object({ username: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachByUsername } = await import("~/lib/server/coach");
    const { isCoachHiddenFromRequest } =
      await import("~/lib/server/coach-visibility");
    const coach = await getCoachByUsername(data.username);
    if (!coach || (await isCoachHiddenFromRequest(coach))) {
      return { hasMainOffer: false };
    }
    // `mainOffer` only resolves to a published offer.
    return { hasMainOffer: Boolean(coach.mainOffer) };
  });

export const Route = createFileRoute("/_public/discovery/$username/offer/")({
  loader: async ({ params }) => {
    const { username } = params;
    const { hasMainOffer } = await getCoachHasMainOffer({
      data: { username },
    });

    if (!hasMainOffer) {
      throw redirect({
        to: "/discovery/$username",
        params: { username },
      });
    }

    throw redirect({
      to: "/$username",
      params: { username },
    });
  },
});
